import Guidance from "components/views/atoms/Guidance"
import { IPageGuidance } from "contentful-types"
import React from "react"
import { reportErrorMessage } from "../../../utils/ErrorReporting"

type GuidanceElementProps = {
  guidance: IPageGuidance
}

const GuidanceElement = ({ guidance }: GuidanceElementProps) => {
  if (!guidance || !guidance.fields) {
    if (guidance) {
      reportErrorMessage(`Missing fields data for Contentful page guidance with entityId: ${guidance.sys.id}`)
    }
    return null
  }
  const {
    fields: { title, description }
  } = guidance
  return <>{title && description ? <Guidance title={title} description={description} /> : null}</>
}

export { GuidanceElement }
